import React from 'react';
import Button from '../includes/button';
import AboutAnimation from './about-animation';


const AboutContentBlock = ({ id, heading, textContent, animationName, showContactButton }) => {
    const isOdd = id % 2 !== 0;
    return (
       <div className={`container mx-auto flex lg:flex-row flex-col-reverse justify-between relative items-stretch py-20 px-6 gap-16` + (isOdd ? ' lg:flex-row' : ' lg:flex-row-reverse')}>
            <div className="w-full max-w-[520px] flex flex-col gap-7 items-start justify-center text-left">
                <div className="flex flex-col gap-1.5 items-start">
                    <span className="border-grey45 border-b border-solid font-bold text-xl font-sans leading-7">{id}</span>
                    <h2 className="text-blue10 text-2xl md:text-3xl font-bold font-sans leading-none">{heading}</h2>
                </div>
                <p className="leading-normal text-grey45 text-base md:text-lg">{textContent}</p>
                {showContactButton && <Button variant='light-secondary' to='/pricing' isHashLink={true} label='Find Your Partnership' className="md:!w-64" />}
            </div>
            <div className='w-full max-w-[720px] flex justify-center items-center bg-aboutSectionAnimation h-[540px] rounded-3xl'>
                <AboutAnimation animationName={animationName} />
            </div>
       </div>
    );
};

export default AboutContentBlock;